export default __webpack_public_path__ + "static/media/K2700Gallery3.b52c50a5.jpg";